import ExampleDriver from './components/ExampleDriver';
import monacoLoader from '@monaco-editor/loader';
import 'simplebar-react/dist/simplebar.min.css';
import './style.scss';

export default ExampleDriver;
export const config = monacoLoader.config;
